<script setup lang=ts>
import { OrButtonV3, OrInputV3, OrModalV3 } from '@onereach/ui-components';
import { ref } from 'vue';

import useI18n from '@/composables/useI18n';

const props = defineProps<{
  isOpenRecovery2fa: boolean;
  recoveryError?: string;
  isLoading: boolean;
  modelValue: string | undefined;
}>();

const emit = defineEmits<{
  (e: 'submit'): void;
  (e: 'toogleOpenRecovery2fa', value: boolean): void;
  (e: 'update:modelValue', value: string | undefined): void;
}>();

const { translate } = useI18n();

const emptyError = ref('');

const updateModelValue = (value: string | undefined) => {
  const trimmed = value === undefined ? value : value.trim();
  emit('update:modelValue', trimmed);
  emptyError.value = '';
  return trimmed;
};

const handleSubmit = () => {
  if (!props.modelValue || props.modelValue.trim() === '') {
    emptyError.value = translate('login.password_restore.This field is required');
  } else {
    emit('submit');
  }
};

const handleClose = () => {
  emptyError.value = '';
  emit('toogleOpenRecovery2fa', false);
};
</script>

<template>
  <OrModalV3
    size="s"
    :is-open="isOpenRecovery2fa"
    class="recovery-modal"
    @close="handleClose"
  >
    <template #header>
      <div>{{ translate('login.login.accessRecovery') }}</div>
    </template>
    <template #default>
      <div class="layout-column gap-md">
        <div>
          {{ translate('login.login.ifYouHaveProblems') }}
        </div>
        <OrInputV3
          :model-value="modelValue"
          :label="translate('login.login.recoveryCode')"
          :error="recoveryError || emptyError"
          @update:modelValue="updateModelValue"
          @keyup.enter.native="handleSubmit"
        />
        <div>
          {{ translate('login.login.ifYouveLost') }}
        </div>
      </div>
    </template>
    <template #footer>
      <div class="layout-row gap-md justify-between md:justify-end">
        <OrButtonV3
          variant="outlined"
          class="flex-1 md:!flex-none"
          :disabled="isLoading"
          @click="handleClose"
        >
          {{ translate('login.login.cancel') }}
        </OrButtonV3>
        <OrButtonV3
          color="primary"
          class="flex-1 md:!flex-none"
          :disabled="!!emptyError"
          :loading="isLoading"
          @click="handleSubmit"
        >
          {{ translate('login.login.submit') }}
        </OrButtonV3>
      </div>
    </template>
  </OrModalV3>
</template>
